import React from 'react'
import { MenuItem, Select } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { useMainState } from '@core/main-state'

const languages = [
  { code: 'en', name: 'English' },
  { code: 'ja', name: '日本語' },
  { code: 'es', name: 'Español' },
]

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation()
  const isInternalAdmin = useMainState((state) => state.user?.internalAdmin)

  // Only show for internal admins (feature flag will be added in follow-up)
  if (!isInternalAdmin) {
    return null
  }

  const handleLanguageChange = (newLanguage: string) => {
    i18n.changeLanguage(newLanguage)
  }

  return (
    <Select
      value={i18n.language}
      onChange={(e) => handleLanguageChange(e.target.value as string)}
      size="small"
      sx={{
        minWidth: 120,
        '.MuiOutlinedInput-notchedOutline': {
          border: 'none',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
          border: 'none',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          border: 'none',
        },
      }}
    >
      {languages.map(({ code, name }) => (
        <MenuItem key={code} value={code}>
          {name}
        </MenuItem>
      ))}
    </Select>
  )
}
